import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ion-padding ion-text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "ion-padding ion-text-center"
}
const _hoisted_3 = {
  key: 2,
  class: "ion-padding event-detail"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "event-detail-title" }
const _hoisted_6 = { class: "event-detail-meta" }
const _hoisted_7 = {
  key: 0,
  class: "event-detail-location"
}
const _hoisted_8 = { class: "event-detail-desc" }
const _hoisted_9 = {
  key: 2,
  class: "event-tiers"
}
const _hoisted_10 = {
  key: 3,
  class: "event-refund-note"
}
const _hoisted_11 = {
  key: 4,
  class: "qr-block"
}
const _hoisted_12 = { class: "qr-wrap qr-liga-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/events"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Событие", -1)
                ]))]),
                _: 1
              }),
              (_ctx.event && _ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "end",
                    class: "event-detail-header-actions"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/admin-events/${_ctx.event.id}/edit`)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IonIcon, { icon: _ctx.createOutline }, null, 8, ["icon"]),
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "header-btn-label" }, "Редактировать", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/admin-events/${_ctx.event.id}/registrations`)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IonIcon, { icon: _ctx.peopleOutline }, null, 8, ["icon"]),
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "header-btn-label" }, "Участники", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Загрузка..."))
            : (!_ctx.event)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Событие не найдено."))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.event.logoPath ? _ctx.eventsService.logoUrl(_ctx.event.logoPath) : _ctx.defaultEventLogo,
                    class: "event-detail-logo",
                    alt: _ctx.event.title
                  }, null, 8, _hoisted_4),
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.event.title), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.event.startAt)), 1),
                  (_ctx.event.location)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.event.location), 1))
                    : _createCommentVNode("", true),
                  (_ctx.event.description)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "event-detail-desc-label" }, "Программа / Описание", -1)),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.event.description), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.event.isPaid && _ctx.event.priceTiers?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "tiers-label" }, "Тарифы:", -1)),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.priceTiers, (t) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: t.id
                            }, _toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽", 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.myReg)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          class: "event-register-btn",
                          disabled: _ctx.registering,
                          onClick: _ctx.register
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" Записаться ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        (_ctx.event.isPaid && _ctx.event.priceTiers?.length)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select, {
                                  label: "Тариф",
                                  "cancel-text": "Отмена",
                                  modelValue: _ctx.selectedTierId,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTierId) = $event)),
                                  interface: "action-sheet",
                                  placeholder: "Выберите"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.priceTiers, (t) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: t.id,
                                        value: t.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createVNode(_component_ion_note, { class: "reg-status" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Вы записаны" + _toDisplayString(_ctx.event.isPaid && !_ctx.myReg.paid ? '. Оплатите участие.' : ''), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.event.isPaid && !_ctx.myReg.paid && _ctx.event.priceTiers && _ctx.event.priceTiers.length >= 2)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none",
                              class: "event-tier-select-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select, {
                                  label: "Тариф",
                                  "cancel-text": "Отмена",
                                  modelValue: _ctx.selectedTierIdForPay,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTierIdForPay) = $event)),
                                  interface: "action-sheet",
                                  placeholder: "Выберите тариф"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.priceTiers, (t) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: t.id,
                                        value: t.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽ ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showPayButton)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              expand: "block",
                              class: "event-pay-btn",
                              disabled: _ctx.paying,
                              onClick: _ctx.goPay
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Оплатить " + _toDisplayString((_ctx.amountToPayKopecks / 100).toFixed(0)) + " ₽ ", 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.event.isPaid && !_ctx.myReg.paid)
                          ? (_openBlock(), _createBlock(_component_ion_note, {
                              key: 2,
                              class: "offer-note"
                            }, {
                              default: _withCtx(() => [
                                _cache[11] || (_cache[11] = _createTextVNode(" Нажимая «Оплатить», вы соглашаетесь с ", -1)),
                                _createVNode(_component_router_link, { to: "/offer-supplement" }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("договором оферты и дополнением о платных событиях", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[12] || (_cache[12] = _createTextVNode(". ", -1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.event.isPaid && !_ctx.myReg.paid)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                              _cache[14] || (_cache[14] = _createTextVNode(" Условия возврата средств: см. ", -1)),
                              _createVNode(_component_router_link, { to: "/offer-supplement" }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("Дополнение к оферте", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[15] || (_cache[15] = _createTextVNode(". ", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.myReg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "qr-label" }, "QR-код для входа", -1)),
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_qrcode_vue, {
                                  value: _ctx.qrPayload,
                                  size: 200,
                                  level: "M",
                                  margin: 1,
                                  options: _ctx.qrOptions
                                }, null, 8, ["value", "options"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.eventNotStarted)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 5,
                              expand: "block",
                              fill: "outline",
                              color: "warning",
                              class: "event-cancel-btn",
                              disabled: _ctx.cancelling,
                              onClick: _ctx.confirmCancelRegistration
                            }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode(" Отменить участие ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}